module.exports = __webpack_public_path__ + "static/media/next-steps-4.3378554b.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/next-steps-4.png
// module id = 2636
// module chunks = 0